import { Branch, FinancialInstitutionLender } from '@models/lender';
import { LawFirm } from '@models/lawFirms';
import { LawFirmEmployee } from '@models/lawFirms';

export class RequestFinancialInstitutionChange {
	static readonly type =
		'[global data management] request financial institution';
	constructor(public institution: FinancialInstitutionLender) {}
}

export class RequestBranchChange {
	static readonly type =
		'[global data management] request financial institution branch';
	constructor(public payload: { institutionId: string; branch: Branch }) {}
}

export class RequestLawFirmChange {
	static readonly type = '[global data management] request law firm change';
	constructor(public lawfirm: LawFirm) {}
}

export class RequestLawFirmEmployeeChange {
	static readonly type =
		'[global data management] request law firm employee change';
	constructor(
		public payload: { lawfirmId: string; lawfirmEmployee: LawFirmEmployee },
	) {}
}
